import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC } from "react";
import { CompanyServiceSummary } from "src/apis/company";
import { formatDateToBR } from "src/utils/date";

type ServicesByCompanySummaryTableProps = {
  summary: CompanyServiceSummary;
  startDate: string;
  endDate: string;
}

const ServicesByCompanySummaryTable: FC<ServicesByCompanySummaryTableProps> = ({summary, startDate, endDate}) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableCell colSpan={2}><strong>Resumo de atendimentos, período de {formatDateToBR(startDate)} até {formatDateToBR(endDate)}</strong></TableCell>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell><strong>Empresa</strong></TableCell>
            <TableCell>{summary?.nome_empresa}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Atendimentos</strong></TableCell>
            <TableCell>{summary?.qtde_atendimentos}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Ações</strong></TableCell>
            <TableCell>{summary?.qtde_acoes}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Valor Atendimentos</strong></TableCell>
            <TableCell>R$ {summary?.montante_total_atendimentos}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Valor Mensalidade</strong></TableCell>
            <TableCell>R$ {summary?.montante_mensalidade}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Valor Total (Atendimentos e Mensalidade)</strong></TableCell>
            <TableCell>R$ {summary?.montante_total_atendimentos_e_mensalidade}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Colaboradores atendidos</strong></TableCell>
            <TableCell>
              {summary?.colaboradores_atendidos?.map((nomeColaborador) => (
                <p>{nomeColaborador}</p>
              ))}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Atendimentos por</strong></TableCell>
            <TableCell>
              {summary?.psicologos?.map((nomePsicologo) => (
                <p>{nomePsicologo}</p>
              ))}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ServicesByCompanySummaryTable;
